import { db, livePendingEvents, type PendingEvent } from '@/lib/db'

/*
 * Kolejka offline jest już tylko DO OPRÓŻNIENIA. Nowe kliknięcia nie trafiają
 * do IndexedDB — start/koniec pracy istnieje dopiero, gdy potwierdzi go serwer.
 * Zostaje odczyt i wysyłka zdarzeń, które na telefonach zapisała poprzednia
 * wersja aplikacji (i stare bundle, dopóki się nie zaktualizują).
 */

/** Kolejka wysyłkowa w kolejności zdarzeń — bez trwale odrzuconych. */
export async function getPendingEvents(): Promise<PendingEvent[]> {
  const rows = await livePendingEvents().toArray()
  return rows.sort((a, b) => a.createdAt - b.createdAt)
}

export async function removePendingEvent(id: number): Promise<void> {
  await db.pendingEvents.delete(id)
}

export async function bumpAttempt(id: number, error: string | null): Promise<void> {
  const ev = await db.pendingEvents.get(id)
  if (!ev) return
  await db.pendingEvents.update(id, {
    attempts: ev.attempts + 1,
    lastAttemptAt: Date.now(),
    lastError: error,
  })
}

/**
 * Backend odrzucił zdarzenie trwale (400/409/422) — zostaje w IndexedDB jako
 * ślad (godzina kliknięcia + GPS), ale wypada z kolejki wysyłkowej.
 */
export async function markDead(id: number, reason: string): Promise<void> {
  await db.pendingEvents.update(id, {
    deadAt: Date.now(),
    deadReason: reason,
  })
}

/**
 * Wyjście awaryjne: zaległy zapis, który nie chce przejść, blokuje przycisk
 * start/koniec. Pracownik może go pominąć — wpisy zostają w IndexedDB jako
 * ślad, a sesję dopisuje admin.
 */
export async function discardLiveEvents(reason: string): Promise<number> {
  const deadAt = Date.now()
  return livePendingEvents().modify({ deadAt, deadReason: reason })
}

/**
 * Wykładniczy backoff dla zdarzeń, które odbiły się od serwera (5xx, 429, brak
 * sieci). Bez tego SyncController przy każdym `visibilitychange` powtarzałby ten
 * sam nieudany request.
 */
export function backoffReadyAt(ev: PendingEvent): number {
  if (ev.attempts === 0 || ev.lastAttemptAt === null) return 0
  const delayMs = Math.min(5 * 60_000, 2 ** Math.min(ev.attempts, 8) * 1000)
  return ev.lastAttemptAt + delayMs
}
